import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DisplaySettingsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"display_settings"}/>
}
